module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "notfications"
  }, [_vm._c('ul', [_vm._l((_vm.allNotifications), function(n) {
    return _vm._c('li', {
      staticClass: "notification"
    }, [_vm._c('router-link', {
      attrs: {
        "to": {
          name: n.navLocation
        }
      }
    }, [_vm._v(_vm._s(n.message))]), _vm._v(" "), (_vm.showDelete === true) ? _vm._c('span', {
      on: {
        "click": function($event) {
          _vm.removeNotification(n)
        }
      }
    }, [_vm._c('i', {
      staticClass: "fas fa-times"
    })]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.allNotifications.length > 0) ? _vm._c('li', {
    staticClass: "clear-all notification",
    on: {
      "click": function($event) {
        _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("Cleare all notifications")]) : _vm._c('li', {
    staticClass: "xs-p-20"
  }, [_vm._v("No new notifications")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dd03562!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/notifications/NotificationList.vue
// module id = 648
// module chunks = 1